import {COPILOT_PATH} from '@github-ui/copilot-chat-helpers/copilot-chat-helpers'
import {useNavigate} from '@github-ui/use-navigate'
import {useCallback} from 'react'

import type {SelectThreadOptions} from '../utils/copilot-chat-manager'
import {useChatStateLens} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'

/**
 * Navigate to the new thread page.
 * In assistive mode, creates a new thread in-place without navigating away.
 */
export function useNavigateToNewThread() {
  const manager = useChatManager()
  const navigate = useNavigate()
  const isAssistive = useChatStateLens(s => s.mode === 'assistive')

  return useCallback(
    async (newThreadOptions?: SelectThreadOptions) => {
      if (isAssistive) {
        await manager.selectThread(null, newThreadOptions)
        return
      }

      if (window.location.pathname !== COPILOT_PATH) {
        navigate(COPILOT_PATH)
      }

      await manager.selectThread(null, newThreadOptions)
    },
    [manager, navigate, isAssistive],
  )
}
